import React from 'react'
import RecordRTC from 'recordrtc';
import ReactAudioPlayer from 'react-audio-player';

const isEdge = navigator.userAgent.indexOf('Edge') !== -1 && (!!navigator.msSaveOrOpenBlob || !!navigator.msSaveBlob);
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

const hasGetUserMedia = !!(window.navigator.getUserMedia || window.navigator.webkitGetUserMedia ||
    window.navigator.mozGetUserMedia || window.navigator.msGetUserMedia);

const IconStop = () => <svg className="bi bi-stop-fill" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
    <path d="M5 3.5h6A1.5 1.5 0 0 1 12.5 5v6a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 11V5A1.5 1.5 0 0 1 5 3.5z"/>
</svg>

const IconPlay = () => <svg className="bi bi-play-fill" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
    <path
        d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
</svg>

const IconRecord = () => <svg className="bi bi-mic-fill" width="1em" height="1em" viewBox="0 0 20 20"
                              fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 3a3 3 0 0 1 6 0v5a3 3 0 0 1-6 0V3z"/>
    <path fillRule="evenodd"
          d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5z"/>
</svg>

function captureMicrophone(callback) {
    const error = 'Your browser seems to not support audio recording: Please try Google Chrome or Firefox (on iOS unfortunately recording unfortunately doesn\'t work at all).';

    if(typeof navigator.mediaDevices === 'undefined' || !navigator.mediaDevices.getUserMedia) {
        alert(error);

        if(!!navigator.getUserMedia) {
            alert(error);
        }
    }

    navigator.mediaDevices.getUserMedia({
        audio: isEdge ? true : {
            echoCancellation: false
        }
    }).then(function(mic) {
        callback(mic);
    }).catch(function(error) {
        alert(error);
        console.error(error);
    });
}

class AudioRecorder extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isRecording: false,
            isPlaying: false,
            src: null,
        };
    }

    componentDidUpdate({shouldAutoSubmit}) {
        if(!shouldAutoSubmit && this.props.shouldAutoSubmit && this.state.recordVideo) {
            this.stopRecord();
        }
    }

    startRecord = () => {
        captureMicrophone((stream) => {
            this.state.recordVideo = RecordRTC(stream, {type: 'audio'});
            this.state.recordVideo.startRecording();
            this.setState({
                isRecording: true
            });
        });
    }

    stopRecord = () => {
        return new Promise((resolve, reject) => {
            this.state.recordVideo.stopRecording(() => {
                const blob = this.state.recordVideo.getBlob();
                const src = URL.createObjectURL(blob);

                this.setState({
                    src,
                    isRecording: false
                });

                this.props.onChange(blob)
                resolve(src);
            });
        });
    }

    startPlay = () => {
        this.setState({
            isPlaying: true
        });
    };

    stopPlay = () => {
        this.setState({
            isPlaying: false
        });
    };

    render() {
        const { isRecording, src, isPlaying } = this.state;

        return(
            <div>
                {!isRecording && <button className="recorder-button btn btn-outline-primary" onClick={this.startRecord}>{<IconRecord />}{src ? 'Record again': 'Record answer'}</button>}
                {!isRecording && !isPlaying && src && <button className="recorder-button btn btn-outline-primary" onClick={this.startPlay}>{<IconPlay />} Listen</button>}
                {!isRecording && isPlaying && src && <button className="recorder-button btn btn-outline-primary" onClick={this.stopPlay}>{<IconStop />} Stop</button>}
                {!isRecording && isPlaying && src && <ReactAudioPlayer
                    src={src}
                    autoPlay
                    onEnded={this.stopPlay}
                    />}
                {isRecording && <button className="recorder-button stop-record btn btn-outline-primary" onClick={this.stopRecord}>{<IconRecord />} Finish</button>}

            </div>
        )
    }
}

export default AudioRecorder;